export const FormField = {
  avatarFile: 'avatarFile',
} as const;
